/**
 * Status-Schwelle, auf die sich mehrere Health-Check-Regeln beziehen (#1283).
 *
 * Die Zahl stand vorher dreimal roh im Code — einmal als Konstante in
 * `masterData`, zweimal als literales `5` in `clients` und `invoices`. Damit
 * war beim Lesen nicht erkennbar, dass sich alle drei auf dieselbe Schwelle
 * beziehen, und eine Änderung hätte zwei Stellen übersehen.
 *
 * Bewusst hier und nicht projektweit: die rohe `5` steht auch im Dashboard und
 * in `InvoiceWarning`. Das aufzuräumen ist eine eigene Aufgabe und gehört nicht
 * in dieses Ticket.
 */

/** Status „Laufend" — ab hier ist der Vorgang im Mandantenportal sichtbar. */
export const STATE_IN_PROGRESS = 5;
